/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityIncognitoSpyIcon24Solid = forwardRef('SecurityIncognitoSpyIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.272 4.829 3.892 10.5H1.25a1.25 1.25 0 1 0 0 2.5h21.5a1.25 1.25 0 0 0 0-2.5h-2.642l-1.38-5.671a2.75 2.75 0 0 0-4.182-1.648l-1.86 1.221a1.25 1.25 0 0 1-1.372 0L9.454 3.18A2.75 2.75 0 0 0 5.272 4.83Z" }),
        React.createElement("path", { d: "M11.25 17.5V17h1.5v.5a4 4 0 0 0 8 0v-1.25c0-.69-.56-1.25-1.25-1.25h-15c-.69 0-1.25.56-1.25 1.25v1.25a4 4 0 0 0 8 0Z" })));
});
